import script from "./DialogSignup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogSignup.vue?vue&type=script&setup=true&lang=ts"

import "./DialogSignup.vue?vue&type=style&index=0&id=6bae03ac&lang=scss"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QCheckbox,QSeparator,QCardActions});
